module.exports = __webpack_public_path__ + "static/img/th-crads-invest2-07.7455c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnails/th-crads-invest2-07.png
// module id = et/T
// module chunks = 1